const fi = require('../webComponents/localization/fi-FI.json');
const sv = require('../webComponents/localization/sv-FI.json');

export function translate(word) {
  const voc = window.preferredLanguage ? (window.preferredLanguage === 'fi-FI' ? fi : sv) : fi;
  return word.split('.').reduce(((vocabulary, pathPart) => vocabulary && vocabulary[pathPart]), voc) || `#${word}#`;
}
